const posIdMap = {
  en: '81444771',
  ru: '81444772',
  ua: '81444773',
  el: '81444770',
};

// @ts-ignore
export const getPiraeusPosID = (lang: string) => posIdMap[lang];
